var _rect, _path, _path2, _rect2, _rect3, _rect4, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.26953,
    y: 2.53809,
    width: 15.4597,
    height: 12.8831,
    rx: 2,
    stroke: "#1D1D46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70508 0.820312L4.70508 2.53806",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2949 0.820312L13.2949 2.53806",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.69141,
    y: 7.86426,
    width: 2.45054,
    height: 1.71775,
    rx: 0.5,
    fill: "#1D1D46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.77539,
    y: 7.86426,
    width: 2.45054,
    height: 1.71775,
    rx: 0.5,
    fill: "#1D1D46"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8594,
    y: 7.86426,
    width: 2.45054,
    height: 1.71775,
    rx: 0.5,
    fill: "#1D1D46"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.26953,
    y1: 5.47363,
    x2: 16.7293,
    y2: 5.47363,
    stroke: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendar_date.c3f82b32c89186437d6d7a37a72715c7.svg";
export { ForwardRef as ReactComponent };